import React from 'react'
import PropTypes from 'prop-types';
import { DefaultSeo } from 'next-seo';
import { useRouter } from 'next/router';

import OrganisationJsonLd from '@atoms/JsonLd/OrganisationJsonLd';

import { getUrlFromRoute } from '@app/helpers';

function OrganisationSeo({organisation}) {
    const router = useRouter();
    const description = organisation.description.slice(0, 300);
    const organisationUrl = getUrlFromRoute('organisation_view', { 
        params: {
            slug: organisation.slug
        },
        locale: router.locale
    });

    return (
        <>
            <DefaultSeo
                title={organisation.name}
                locale
                description={description}
                openGraph={{
                    url: organisationUrl,
                    title: organisation.name,
                    description,
                    images: [
                        {
                            url: organisation.logo.path,
                            width: 800,
                            height: 600,
                            alt: `Cover - ${organisation.name}`,
                        }
                    ],
                    site_name: 'Mubazar',
                }}
            />
            <OrganisationJsonLd
                url={organisationUrl}
                name={organisation.name}
                description={description}
                logo={organisation.logo.path}
                email={organisation.email}
                website={organisation.website}
            /> 
        </>
    )
}


OrganisationSeo.propTypes = {
    organisation: PropTypes.object.isRequired
};


export default OrganisationSeo
